import Emoji from '@shared/ui/Emoji/Emoji';
import { FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

interface ArticleCardProps {
  id?: string;
  title?: string;
  count?: number;
  pinned?: boolean;
  loading?: boolean;
  description?: string;
  icon?: ReactNode;
  unifiedIcon?: string;
  onClick?: (id: string) => void;
}

const ArticleCard: FC<ArticleCardProps> = ({
  id,
  title,
  count,
  pinned = false,
  loading = false,
  description,
  icon,
  unifiedIcon,
  onClick,
}) => {
  const { t } = useTranslation();

  if (loading || !title || !id || count === undefined) {
    return (
      <div className="flex shadow-lg shadow-base-300 rounded-box bg-base-100 p-4 items-center">
        <div className="flex flex-col gap-1 w-full">
          <div className="flex flex-col gap-2">
            <div className="skeleton h-6 w-50"></div>
            <div className="skeleton h-3 w-30"></div>
          </div>

          <div className="flex gap-4 mt-3 items-center w-full">
            <div className="skeleton h-6 w-16"></div>
            <div className="flex gap-1 items-center">
              <div className="skeleton h-4 w-4 rounded-full"></div>
              <div className="skeleton h-3 w-6"></div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      className="flex shadow-lg shadow-base-300 rounded-2xl bg-base-100 p-4 items-center cursor-pointer"
      onClick={() => onClick?.(id)}
    >
      <div className="flex flex-col gap-1 w-full">
        <div className="flex gap-2 text-lg font-bold">
          {icon && <div>{icon}</div>}
          {unifiedIcon && (
            <div>
              <Emoji unified={unifiedIcon} />
            </div>
          )}
          <h3>{title.replace(/-/g, '')}</h3>
        </div>
        {description && <span className="opacity-55 text-sm mt-1">{description}</span>}
        <div className="flex gap-4 mt-3 items-center w-full">
          {pinned && (
            <div className="flex gap-1 items-center text-xs text-primary font-medium">
              <div className="icon-[solar--star-bold-duotone] h-5 w-5 text-primary" />
              {t('contents.tips.pinned')}
            </div>
          )}
          <div className="flex gap-1 items-center text-xs">
            <div className="icon-[solar--fire-bold-duotone] h-5 w-5 text-primary" />
            <div className="text-sm opacity-55">{count}</div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ArticleCard;
